module.exports = __webpack_public_path__ + "static/media/wallTask.f6a0e0f7.jpeg";